// กรอบเปล่าพร้อมข้อความ ใช้ตอนยังไม่ได้ผูกช่องทางนั้นกับแบรนด์
import { Link } from "react-router";
import { useAppSelector } from "@/app/hooks";
import { isAdmin } from "@features/auth/lib/roles";

export function NotConnected({ what }: { what: string }) {
  return (
    <div className="embed-empty">
      <h3>ยังไม่ได้เชื่อม {what}</h3>
      <p className="muted">
        ผูกเพจ {what} ให้แบรนด์นี้ได้ที่ <Link to="/setting/product">Setting → Product</Link>
      </p>
    </div>
  );
}

/**
 * แบรนด์นี้ยังไม่ได้ล็อกเพจไว้ จึงไม่มีเพจไหนที่เปิดดูได้
 *
 * ของเดิมกรณีนี้ส่ง iframe ไปโดยไม่ใส่ ?page= ซึ่ง Inbox Center แปลว่า "ทุกเพจที่
 * บัญชีเข้าถึงได้" — คนที่เปิดแบรนด์หนึ่งจึงเห็นแชทของทุกแบรนด์ในเครือปนกัน ทั้งที่
 * ตั้งใจจำกัดสิทธิ์ไว้ที่แบรนด์ · "ยังไม่ได้ตั้งค่า" ต้องแปลว่าไม่มีสิทธิ์ ไม่ใช่มีทุกสิทธิ์
 */
export function NoPageAccess() {
  const session = useAppSelector((s) => s.session.current);
  return (
    <div className="embed-empty">
      <h3>ไม่มีสิทธิในการเข้าถึงเพจนี้</h3>
      <p className="muted">
        แบรนด์นี้ยังไม่ได้กำหนดเพจไว้ —{" "}
        {isAdmin(session) ? (
          <>
            เลือกเพจให้แบรนด์นี้ได้ที่{" "}
            <Link to="/setting/product">Setting → Channels &amp; Inbox</Link>
          </>
        ) : (
          "ติดต่อผู้ดูแลระบบเพื่อผูกเพจให้แบรนด์นี้ก่อน"
        )}
      </p>
    </div>
  );
}
